// @flow
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdAttachFile } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import Button from '../Button';

import Avatar from '../../../assets/images/avatar.png';
import styles from './profileImagePicker.css';

type ProfileImagePickerProps = {
  value?: any,
  onChange?: Function,
}

const ProfileImagePicker = ({
  value = {},
  onChange = () => {},
}: ProfileImagePickerProps) => {
  const onDrop = useCallback((files: any) => {
    const temp = {
      file: files[0],
      preview: URL.createObjectURL(files[0]),
    };
    if (onChange) onChange(temp);
  }, []);

  const {
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop,
    multiple: false,
  });

  return (
    <div className={styles.container}>
      <div className={styles.profileImage}>
        <img src={value.preview || Avatar} alt="profileimage" />
      </div>
      <div className={styles.pickerArea}>
        <div>
          <input {...getInputProps()} />
          <Button {...getRootProps()} Icon={MdAttachFile} title={i18n.t('common.uploadPhoto')} tint="mediumGray" />
        </div>
        <div className={styles.size}>
          <div className={styles.hightlight}>
            Tamaño sugerido:
          </div>
          250px * 250px
        </div>
      </div>
    </div>
  );
};

export default ProfileImagePicker;



// WEBPACK FOOTER //
// ./src/scripts/components/ProfileImagePicker/index.jsx